import L from "leaflet";
import React from "react";
import { MapControl } from "react-leaflet";
import { render } from "react-dom";

import { MuiThemeProvider } from "@material-ui/core/styles";
import spTheme from "../spTheme";

const DivControl = L.Control.extend({
  onAdd: () => {
    const container = L.DomUtil.create("div");
    L.DomEvent.disableClickPropagation(container);
    return container;
  },
});

export class CustomLeafletControl extends MapControl {
  createLeafletElement({ position }) {
    this.leafletElement = new DivControl({ position });
    return this.leafletElement;
  }

  updateLeafletElement(fromProps, toProps) {
    super.updateLeafletElement(fromProps, toProps);
    this.renderContent();
  }

  renderContent() {
    const container = this.leafletElement.getContainer();

    render(
      <MuiThemeProvider theme={spTheme}>{this.props.children}</MuiThemeProvider>,
      container,
    );
  }
};
